import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { Thumbnail } from "components/common/ui/Thumbnail";
import { CargoClaimDetail, InventoryItem, getImage } from "../../../../models";

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 15px;
`;

export const InventoryItemTitle = ({
  item,
  cargoClaimDetail,
}: {
  item?: InventoryItem;
  cargoClaimDetail?: CargoClaimDetail;
}) => {
  const imgSrc = getImage(item);
  const title = item
    ? `${item.lotNumber}-${item.tagNumber}-${item.tagColor}: ${item.itemName}`
    : `Unlisted item: ${cargoClaimDetail?.unlistedItemName}`;
  return (
    <Wrapper>
      <Thumbnail src={imgSrc} />
      <Typography variant="sHeading">{title}</Typography>
    </Wrapper>
  );
};
